<template>
    <GlobalWindow
        :title="title"
        :visible.sync="visible"
        :confirm-working="isWorking"
        @confirm="confirm"
    >
        <el-form :model="form" ref="form" :rules="rules">
            <el-form-item label="所属城市" prop="cityId">
                <el-select v-model="form.cityId" placeholder="请选择所属城市">
                    <el-option
                        v-for="item in city"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="头像" prop="avatar">
                <UploadAvatarImage :file="file" @uploadSuccess="uploadSuccess" />
            </el-form-item>
            <el-form-item label="名称" prop="name">
                <el-input v-model="form.name" placeholder="请输入名称" v-trim/>
            </el-form-item>
            <el-form-item label="手机号" prop="mobile">
                <el-input v-model="form.mobile" maxlength="11" placeholder="请输入手机号" v-trim/>
            </el-form-item>
            <el-form-item label="企业微信客服ID" prop="enterpriseId">
                <el-input v-model="form.enterpriseId" placeholder="请输入企业微信客服ID" v-trim/>
            </el-form-item>
            <el-form-item label="说明" prop="described">
                <el-input v-model="form.described" placeholder="请输入说明" v-trim/>
            </el-form-item>
            <el-form-item label="描述" prop="remark">
                <el-input v-model="form.remark" placeholder="请输入描述" v-trim/>
            </el-form-item>
        </el-form>
    </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
import UploadAvatarImage from '@/components/common/UploadAvatarImage'
import { fetchList } from '@/api/rentHouse/rhCityInfo'
export default {
  name: 'OperaRhCustomerServiceWindow',
  extends: BaseOpera,
  components: { GlobalWindow, UploadAvatarImage },
  data () {
    return {
      // 表单数据
      form: {
        id: null,
        name: '',
        mobile: '',
        cityId: '',
        described: '',
        remark: '',
        enterpriseId: '',
        avatar: ''
      },
      // 验证规则
      rules: {
        name: [
          { required: true, message: '请输入客服名称' }
        ],
        mobile: [
          { required: true, message: '请输入客服手机号' }
        ],
        cityId: [
          { required: true, message: '请选择所属城市' }
        ],
        // avatar: [
        //   { required: true, message: '请上传客服头像' }
        // ],
        enterpriseId: [
          { required: true, message: '请输入企业微信客服id' }
        ],
        described: [
          { required: true, message: '请输入说明' }
        ],
        remark: [
          { required: true, message: '请输入描述' }
        ]
      },
      city: [],
      baseUrl: process.env.VUE_APP_API_IMG,
      file: {
        imgurlfull: ''
      }
    }
  },
  created () {
    this.config({
      api: '/rentHouse/rhCustomerService',
      'field.id': 'id'
    })
    this.getCity()
  },
  methods: {
    open (title, target) {
      this.file.imgurlfull = ''
      this.title = title
      this.visible = true
      // 新建
      if (target == null) {
        this.$nextTick(() => {
          this.$refs.form.resetFields()
          this.form[this.configData['field.id']] = null
        })
        return
      }
      // 编辑
      this.$nextTick(() => {
        for (const key in this.form) {
          this.form[key] = target[key]
        }
        if (this.form.avatar) {
          this.file.imgurlfull = this.baseUrl + this.form.avatar
        }
      })
    },
    uploadSuccess (res) {
      this.form.avatar = res.imgurl
      this.file.imgurlfull = res.imgurlfull
    },
    getCity () {
      fetchList({
        page: 1,
        capacity: 99,
        model: {
          display: 1
        }
      }).then(res => {
        this.city = res.records.map(item => {
          return {
            id: item.id,
            name: item.cityName
          }
        })
      })
    }
  }
}
</script>
